// Money formatting, shared across products.
//
// These lived in components/products/invoicing/car-invoice-types.ts, which is
// PRIVATE to the invoicing product. Customer billing puts charge summaries on
// railcar, order and storage pages, and those pages importing from another
// product's directory is exactly the cross-product leak the boundary rules
// exist to stop. The invoicing module re-exports these, so its own call sites
// and their output are unchanged.
//
// The implementations are moved VERBATIM. A per-railcar org must render
// byte-identically after this extraction, so this file is not the place to
// improve the rounding.

export function dollarsFromMicros(micros: number | null | undefined): string {
  if (micros == null) return ""
  return (micros / 1_000_000).toFixed(6).replace(/0+$/, "").replace(/\.$/, "")
}

export function dollarsFromCents(cents: number | null | undefined): string {
  if (cents == null) return ""
  return (cents / 100).toFixed(2)
}

// An absent amount reads as an em dash, never as $0.00 — "not priced" and
// "free" are different answers on an invoice.
export function formatMoney(cents: number | null | undefined): string {
  if (cents == null) return "—"
  return `$${(cents / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export function formatRate(micros: number | null | undefined): string {
  const value = dollarsFromMicros(micros)
  return value ? `$${value}` : "—"
}
